import React from 'react';
import { CheckCircleIcon, PollyLogo } from './icons';

const FEATURES = [
  'KG versioning and history',
  'Schema and node-type explorer',
  'Instance Management and Cypher runner',
  'Query history and saved results',
  'GDS monitoring and management',
];

export function BrandPanel() {
  return (
    <aside className="lp-brand">
      <div className="lp-brand__grid" aria-hidden="true" />
      <div className="lp-brand__glow" aria-hidden="true" />

      <div className="lp-brand__inner">
        <header className="lp-brand__header">
          <div className="lp-brand__mark">
            <PollyLogo size={28} />
          </div>
          <span className="lp-brand__wordmark">
            <span className="lp-brand__polly">Polly</span>
            <span className="lp-brand__sep">/</span>
            <span className="lp-brand__product">Knowledge Graph</span>
          </span>
        </header>

        <div className="lp-brand__hero">
          <span className="lp-brand__pill">Polly KG</span>
          <h1 className="lp-brand__h1">KG Manager</h1>
          <p className="lp-brand__sub">
            Browse graph schemas, run Cypher, and manage knowledge graphs
            across your Polly workspace from one console.
          </p>

          <ul className="lp-brand__features" aria-label="Features">
            {FEATURES.map((feature) => (
              <li key={feature}>
                <CheckCircleIcon />
                {feature}
              </li>
            ))}
          </ul>
        </div>

        <footer className="lp-brand__footer">
          <code className="lp-brand__meta">v2.0.0</code>
        </footer>
      </div>
    </aside>
  );
}
